import { ApiResult } from 'common/models';
import { HttpClient } from 'common/services/http-client.service';

import downloadTemplateConfig from './downloadTemplate.config';
import { msalInstance, protectedResources } from 'common/config/auth.config';
import { ENV_CONFIG } from 'common/config/env.config';
import { HttpHeader } from 'common/enums/api-status.enum';

export class DownloadTemplateService extends HttpClient {
    public static async downloadFile(): Promise<ApiResult<Blob> | undefined> {
        const config = downloadTemplateConfig.getDownloadUrl();
        const acquireTokenResult = await msalInstance.acquireTokenSilent({
            scopes: protectedResources.api.scopes
        });
        const header = {
            [HttpHeader.AUTHORIZATION]: `Bearer ${acquireTokenResult.idToken}`
        };
        const baseUrl = ENV_CONFIG.API_URL;
        return await this.getBlob(baseUrl + config.url, header);
    }
}
